import { inject } from 'vue';
import {
  TokensProviderResponse,
  TokensProviderSymbol
} from '@/providers/flakeTokens.provider';

const defaultProviderResponse = {} as TokensProviderResponse;

/**
 * useTokens Composable
 * Interface to all token static and dynamic metatdata.
 */
export default function useFlakeTokens(): TokensProviderResponse {
  return inject(TokensProviderSymbol, defaultProviderResponse);
}
